"use client";

import { useEffect } from "react";
import { loadPlugin } from "@/lib/capacitor/load-plugin";

/**
 * Android Status Bar Initialization Component
 * Configures status bar on Android using @capacitor/status-bar
 * Does NOT affect iOS behavior
 */
export function AndroidStatusBarInit() {
  useEffect(() => {
    // Only run on native platforms (Capacitor), not web
    if (typeof window === "undefined") return;
    
    const Capacitor = (window as any).Capacitor;
    if (!Capacitor) return;
    
    const platform = Capacitor.getPlatform();
    
    // Only apply on Android, not iOS or web
    if (platform !== "android") return;

    // Add platform-android class to html element for CSS targeting
    document.documentElement.classList.add("platform-android");

    // Initialize Android status bar configuration
    const initializeAndroidStatusBar = async () => {
      try {
        const mod = await loadPlugin("StatusBar", () => import("@capacitor/status-bar"));
        if (!mod?.StatusBar) return; // app built without it: nothing to style
        const { StatusBar, Style } = mod;

        // Enable status bar overlay on Android (content goes under status bar)
        await StatusBar.setOverlaysWebView({ overlay: true });

        // Set background color to app header gradient start (blue)
        await StatusBar.setBackgroundColor({ color: "var(--color-primary-vivid)" });

        // Set status bar style to LIGHT (light icons/text on dark background)
        // This ensures white icons are visible on the blue background
        await StatusBar.setStyle({ style: Style.Light });

        console.log("[AndroidStatusBar] Status bar configured successfully");
      } catch (error) {
        console.error("[AndroidStatusBar] Failed to configure status bar:", error);
        // Fallback: ensure platform class is still added even if plugin fails
      }
    };

    initializeAndroidStatusBar();
  }, []);

  return null; // This component doesn't render anything
}

